const enum MapTypeEnum {
    UseMyCurrentLocation = 1,
    SearchText = 2,
    CurrentBranch = 3
}

export default MapTypeEnum;